import { updateEntities } from '@redux/entities'
import { Schemas } from '@redux/schema'
import { normalize } from 'normalizr'

import api from '@functions/api'

import type {
  Action, EntityOptions, Errors,
} from '@redux/modules/types'

import { CommentModel } from '@domain-group/realhub-backend-api-types'
import { AppDispatch } from '@redux/store'
import { handleError } from '../utils'

const CREATE_REQUEST = 'realbase/comment/CREATE_REQUEST'
const CREATE_SUCCESS = 'realbase/comment/CREATE_SUCCESS'
const CREATE_FAILURE = 'realbase/comment/CREATE_FAILURE'

export type CommentModuleState = {
  creating: boolean,
  errors: Errors,
}

// Initial State
const initialState = {
  creating: false,
  errors: [],
}

export function createRequest(): Action {
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(): Action {
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors: Errors = []): Action {
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function createComment(comment: Partial<CommentModel>, options: EntityOptions = {}) {
  const config = {
    method: 'POST',
    data: JSON.stringify({
      comment,
    }),
  }

  return (dispatch: AppDispatch) => {
    dispatch(createRequest())

    const promise = api('/comments.json', options, config)
      .then(({ data }: { data: CommentModel }) => {
        const normalizedJson = normalize(data, Schemas.COMMENT)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true as const, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false as const, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(
  state: CommentModuleState = initialState,
  action: Action = { type: '' },
) {
  switch (action.type){
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
